import { QueryKey } from '@/configs/queryKeys';
import { Attachment, Translations, UUID } from '@/types/types';
import { AttributeValue } from './AttributeValueApi';
import EntityApi, { BaseEntity } from './EntityApi';
import ProductApi from './ProductApi';

export enum PricingMethod {
	PER_M2 = 'per_m2',
	DIMENSION_RANGES = 'dimension_ranges',
}

export interface DimensionPriceRule {
	widthMin: number;
	widthMax: number;
	heightMin: number;
	heightMax: number;
	basePrice: number;
}

export interface DimensionInputModeConfig {
	id: string;
	name: string;
}

export interface ProductType extends BaseEntity {
	name: string;
	description: string;
	isActive: boolean;
	image?: Attachment;
	availableAttributeValues: AttributeValue[];
	requiredAttributeAnswersIds: UUID[];
	availableAccessoriesIds: UUID[];
	availableFabricsIds: UUID[];
	listOrder: number;
	minLeadTimeDays: number;
	widthOutsideWarranty?: number | null;
	heightOutsideWarranty?: number | null;
	pricingMethod: PricingMethod;
	dimensionPriceRules: DimensionPriceRule[];
	widthInputModes: DimensionInputModeConfig[];
	heightInputModes: DimensionInputModeConfig[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class ProductTypeApi extends EntityApi<ProductType> {
	constructor() {
		super(QueryKey.productTypes);
		this.getCreatorInitialData = this.getCreatorInitialData.bind(this);
	}

	async getCreatorInitialData({
		productTypeId,
		productId,
	}: {
		productTypeId: UUID;
		productId?: UUID;
	}) {
		const productType = await super.mutationGetOne(productTypeId);

		let product;
		if (productId) product = await ProductApi.mutationGetOne(productId);

		return {
			productType,
			product,
		};
	}
}

export default new ProductTypeApi();
